import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NxCheckboxComponent } from '@allianz/ng-aquila/checkbox';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ps20-frontend-auslaendische-adresse-checkbox',
  templateUrl: './auslaendische-adresse-checkbox.component.html',
  styleUrls: ['./auslaendische-adresse-checkbox.component.css'],
  imports: [NxCheckboxComponent, NgClass],
})
export class AuslaendischeAdresseCheckboxComponent {
  @Output() auslaendischeAdresseCheckboxEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() text = '';
  @Input() isChecked = false;
  @Input() alignContentToTheLeft = false;

  clickOnCheckbox(checkboxValue: boolean): void {
    this.auslaendischeAdresseCheckboxEvent.emit(checkboxValue);
  }
}
